<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        申込一覧
      </template>

      <template v-slot:content>

        <v-row class="mb-0 pb-0">
          <v-col cols="2">
            <v-text-field
              v-model="customerId"
              label="お客様No."
              color="secondary"
            />
          </v-col>
          <v-col cols="2">
            <v-text-field
              v-model="searchSchool"
              label="塾名"
              color="secondary"
            />
          </v-col>
          <v-col cols="2">
            <v-select
              v-model="selectedApplyType"
              :items="applyTypes.map(applyType => applyType.name)"
              label="申込種別"
              clearable
            ></v-select>
          </v-col>
        </v-row>
        <v-card>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="filteredSchools"
            item-key="code"
            disable-pagination
            hide-default-footer
            mobile-breakpoint=10
          >
            <!-- 申込種別 -->
            <template #[`item.typeName`]="{ item }">
              <v-chip dark class="my-1 mx-2" :class="getApplyTypeClass(item.typeName)">{{item.typeName}}</v-chip>
            </template>
            <!-- 編集ボタン -->
            <template #[`item.edit`]="{ item }">
              <v-btn icon @click.stop="edit(item)">
                <v-icon small dark>
                  mdi-cog-outline
                </v-icon>
              </v-btn>
            </template>
            <!-- 削除ボタン -->
            <template #[`item.delete`]="{ item }">
              <v-btn icon @click.stop="openDeleteConfirmDialog(item)">
                <v-icon dark>
                  mdi-delete
                </v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </template>
    </v-base-card>

    <v-confirm-dialog
      ref="confirm"
      title="申し込み削除"
      :message="deleteMessage"
      buttonMessage="削除"
      @confirm="confirmDeletion"
    />
  </div>
</template>

<script>
import VBaseCard from "@/components/molecules/BaseCard";
import VConfirmDialog from '@/components/atoms/ConfirmDialog'

export default {
  components: {
    VBaseCard,
    VConfirmDialog,
  },
  data() {
    return {
      selected: [],
      searchSchool: "",
      customerId: "",
      search: "",
      headers: [
        { text: "申込ID", align: "start", value: "id", class: 'list-th' },
        { text: "お客様No.", align: "start", value: "customer.code", class: 'list-th' },
        { text: "EN担当者", align: "start", value: "customer.representative", class: 'list-th' },
        { text: "塾名", align: "center", value: "customer.name", class: 'list-th' },
        { text: "申込種別", align: "center", value: "typeName", sortable: false, class: 'list-th' },
        { text: "申請日", align: "center", value: "createdAt", class: 'list-th' },
        { text: "詳細", align: "center", value: "edit", sortable: false, class: 'list-th' },
        { text: "削除", align: "center", value: "delete", sortable: false, class: 'list-th' },
      ],
      schools: [],
      deletedApply: {},
      applyTypes: [
        { code: 1, name: '新規'},
        { code: 2, name: '教室追加'},
        { code: 3, name: '解約'},
      ],
      selectedApplyType: null,
    };
  },

  async mounted() {
    await this.getSchoolApplies()
  },

  computed: {
    filteredSchools() {
      return this.schools.filter(
        (school) =>
          school.customer.name.includes(this.searchSchool) &&
          school.customer.code.includes(this.customerId) &&
          (!this.selectedApplyType || school.typeName == (this.selectedApplyType))
      );
    },
    deleteMessage() {
      return `申込ID:${this.deletedApply.id}の [${this.deletedApply.typeName}]申し込みを削除します。よろしいですか。`
    },
  },

  methods: {
    async getSchoolApplies() {
      this.loading = true
      const res = await this.$axios('/api/v1/admin/requests')
      this.schools = res.data
      this.loading = false
    },
    openDeleteConfirmDialog(apply) {
      this.deletedApply = apply
      this.$refs.confirm.open()
    },
    async confirmDeletion() {
      const url = `api/v1/admin/requests/${this.deletedApply.id}`
      await this.$axios.delete(url)
      this.$toasted.global.success({ message: `申込ID:${this.deletedApply.id}を削除しました` })
      this.getSchoolApplies()
    },
    getApplyTypeClass(type) {
      let className = 'chip__type'
      if (type === '新規') return className + '-new'
      else if (type === '教室追加') return className + '-add-branch'
      else if (type === '解約') return className + '-delete'
    },
    async edit(apply) {
      await this.$store.commit('apply/setApply', apply)
      this.$router.push(`/admin/school_apply_edit/${apply.id}`)
    },
  }
};
</script>

<style lang="stylus" scoped>

.select
  font-size: 11px !important;

.table-link
  cursor pointer

.regist-button
  position: absolute
  right: 35px

.chip
  &__type
    &-new
      // background-color #3E90C6 !important
      width 64px
      height 19px !important
      font-size 10px !important
      font-weight bold
      // border-bottom 1px solid #c4c4c4
      display inline-block

      background-color: #ffffff !important;
      border: 1px solid #3e90c6;
      color: #3e90c6;

    &-add-branch
      // background-color #4caf50 !important
      width 64px
      height 19px !important
      font-size 10px !important
      font-weight bold
      // border-bottom 1px solid #337f36
      display inline-block

      background-color: #ffffff !important;
      border: 1px solid #4caf50;
      color: #4caf50;

    &-delete
      // background-color #cc564e !important
      width 64px
      height 19px !important
      font-size 10px !important
      font-weight bold
      // border-bottom 1px solid #993f39
      display inline-block

      background-color: #ffffff !important;
      border: 1px solid #cc564e;
      color: #cc564e;

</style>
